<template>
  <div>
    <div
      class="options d-none d-sm-flex py-2 justify-end"
      style="direction: ltr;"
    >
      <span
        v-for="(item, index) in chartTypeTab"
        :key="index"
        class="options-item"
        :class="{ 'primary--text': selectedChartTypeTab === item.value }"
        @click="changeSelectedChartTab(item.value)"
      >
        {{ item.title }}
      </span>
    </div>
    <highcharts
      ref="highcharts"
      id="depth_chart"
      :options="options"
    ></highcharts>
  </div>
</template>
<script>
import Vue from "vue";
import HighchartsVue from "highcharts-vue";
import Highcharts from "highcharts";
import noData from "highcharts/modules/no-data-to-display";
import { MarketMarketService } from "@/services";

noData(Highcharts);
Vue.use(HighchartsVue);

Highcharts.setOptions({
  lang: {
    thousandsSep: ",",
  },
});
export default {
  name: "depthGraph",
  props: {
    currentCoin: {
      type: Object,
    },
    chartTypeTab: {
      type: Array,
    },
    selectedChartTypeTab: {
      type: String,
      default: "trading-view",
    },
  },
  data() {
    return {
      options: this.getInitialOptions(),
    };
  },
  computed: {
    chartBackgroundColor() {
      return this.$vuetify.theme.dark
        ? this.$vuetify.theme.themes.dark.black
        : this.$vuetify.theme.themes.light.white;
    },
    chartTextColor() {
      return this.$vuetify.theme.dark
        ? this.$vuetify.theme.themes.dark.white
        : this.$vuetify.theme.themes.light.black;
    },
  },
  watch: {
    "$vuetify.theme.dark": {
      handler() {
        this.updateChartColors();
      },
    },
  },
  mounted() {
    this.options = {
      chart: {
        type: "area",
        height: "360",
        backgroundColor: this.chartBackgroundColor,
        zoomType: "xy",
        panning: true,
        panKey: "shift",
        style: {
          fontFamily: "webIRANSansRegular, sans-serif",
          fontWeight: "normal",
        },
        resetZoomButton: {
          theme: {
            width: 60,
            height: 8,
            fill: this.chartTextColor,
            stroke: "#f1ac1c",
            r: 4, // borer-radius
            states: {
              hover: {
                fill: "#f1ac1c",
                style: {
                  color: this.chartTextColor,
                },
              },
            },
          },
        },
      },
      responsive: {
        rules: [
          {
            condition: {
              maxWidth: 1100,
            },
          },
        ],
      },
      credits: {
        enabled: false,
      },
      title: false,
      tooltip: {
        useHTML: true,
        formatter: function() {},
        shared: false,
        borderRadius: 4,
        followPointer: true,
        followTouchMove: true,
      },
      lang: {
        noData: this.$t("exchange.noOrders"),
      },
      noData: {
        style: {
          fontWeight: "normal",
          fontSize: "16px",
          color: "#fff",
        },
      },
      legend: {
        itemStyle: {
          color: this.chartTextColor,
        },
      },
      xAxis: [
        {
          labels: {
            rotation: -45,
            style: {
              color: this.chartTextColor,
            },
          },
          reversed: false,
          width: "50%",
          minPadding: 0,
          maxPadding: 0,
        },
        {
          labels: {
            rotation: -45,
            style: {
              color: this.chartTextColor,
            },
          },
          offset: 0,
          left: "50%",
          width: "50%",
          minPadding: 0,
          maxPadding: 0,
        },
      ],
      yAxis: {
        labels: {
          style: {
            color: this.chartTextColor,
          },
        },
        title: {
          text: this.$t("exchange.total"),
          style: {
            color: this.chartTextColor,
          },
        },
        gridLineColor: "gray",
        gridLineDashStyle: "longdash", // Solid, ShortDash, LongDashDot
      },
      plotOptions: {
        area: {
          stacking: "normal",
        },
      },
      series: [
        {
          name: this.$t("exchange.buy"),
          data: [],
          color: "#3ab275",
          xAxis: 0,
        },
        {
          name: this.$t("exchange.sell"),
          data: [],
          color: "#f15057",
          xAxis: 1,
        },
      ],
    };
    this.getData();
  },
  methods: {
    updateChartColors() {
      if (this.$refs.highcharts?.chart) {
        this.$refs.highcharts.chart.update({
          chart: {
            backgroundColor: this.chartBackgroundColor,
          },
          legend: {
            itemStyle: {
              color: this.chartTextColor,
            },
          },
          xAxis: [
            {
              labels: {
                style: { color: this.chartTextColor },
              },
            },
            {
              labels: {
                style: { color: this.chartTextColor },
              },
            },
          ],
          yAxis: {
            labels: {
              style: { color: this.chartTextColor },
            },
            title: {
              style: { color: this.chartTextColor },
            },
          },
        });
      }
    },
    getInitialOptions() {
      return {
        chart: {
          type: "area",
          height: "360",
          backgroundColor: this.chartBackgroundColor,
          zoomType: "xy",
          panning: true,
          panKey: "shift",
          style: {
            fontFamily: "webIRANSansRegular, sans-serif",
            fontWeight: "normal",
          },
          resetZoomButton: {
            theme: {
              width: 60,
              height: 8,
              fill: this.chartTextColor,
              stroke: "#f1ac1c",
              r: 4, // borer-radius
              states: {
                hover: {
                  fill: "#f1ac1c",
                  style: {
                    color: this.chartTextColor,
                  },
                },
              },
            },
          },
        },
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 1100,
              },
            },
          ],
        },
        credits: {
          enabled: false,
        },
        title: false,
        tooltip: {
          useHTML: true,
          formatter: function() {},
          shared: false,
          borderRadius: 4,
          followPointer: true,
          followTouchMove: true,
        },
        lang: {
          noData: this.$t("exchange.noOrders"),
        },
        noData: {
          style: {
            fontWeight: "normal",
            fontSize: "16px",
            color: "#fff",
          },
        },
        legend: {
          itemStyle: {
            color: this.chartTextColor,
          },
        },
        xAxis: [
          {
            labels: {
              rotation: -45,
              style: {
                color: this.chartTextColor,
              },
            },
            reversed: false,
            width: "50%",
            minPadding: 0,
            maxPadding: 0,
          },
          {
            labels: {
              rotation: -45,
              style: {
                color: this.chartTextColor,
              },
            },
            offset: 0,
            left: "50%",
            width: "50%",
            minPadding: 0,
            maxPadding: 0,
          },
        ],
        yAxis: {
          labels: {
            style: {
              color: this.chartTextColor,
            },
          },
          title: {
            text: this.$t("exchange.total"),
            style: {
              color: this.chartTextColor,
            },
          },
          gridLineColor: "gray",
          gridLineDashStyle: "longdash", // Solid, ShortDash, LongDashDot
        },
        plotOptions: {
          area: {
            stacking: "normal",
          },
        },
        series: [
          {
            name: this.$t("exchange.buy"),
            data: [],
            color: "#3ab275",
            xAxis: 0,
          },
          {
            name: this.$t("exchange.sell"),
            data: [],
            color: "#f15057",
            xAxis: 1,
          },
        ],
      };
    },
    getData() {
      let payload = {
        symbol: this.currentCoin.symbol,
      };
      MarketMarketService.getPlateFullData(payload).then((response) => {
        this.trades = response.data;
        for (let i = 1; i < this.trades.ask.items.length; i++) {
          this.trades.ask.items[i].amount += this.trades.ask.items[
            i - 1
          ].amount;
        }
        this.asks = this.trades.ask.items.map((elem) => {
          return [elem.price, elem.amount];
        });

        for (let i = 1; i < this.trades.bid.items.length; i++) {
          this.trades.bid.items[i].amount += this.trades.bid.items[
            i - 1
          ].amount;
        }
        this.bids = this.trades.bid.items.map((elem) => {
          return [elem.price, elem.amount];
        });
        this.setChartOptions();
      });
    },
    setChartOptions() {
      const price = this.$t("exchange.price");
      const total = this.$t("exchange.total");
      const baseCoinScale = this.currentCoin.frontBaseCoinScale;
      const coinScale = this.currentCoin.frontCoinScale;
      this.options.series[0].data = this.bids;
      this.options.series[1].data = this.asks;
      this.options.tooltip.formatter = function() {
        return `<div style="text-align: right;">
                            ${price}:
                            ${this.point.x.toFixed(baseCoinScale)}<br/>
                            ${total} ${
          this.point.series.name
        }: ${this.point.y.toFixed(coinScale)}
                        </div>`;
      };
    },

    changeSelectedChartTab(value) {
      this.$emit("changeTab", value);
    },
  },
  // beforeUpdate() {
  //   document.getElementById("depth_chart").classList.add("d-block");
  // }
};
</script>
<style scoped lang="scss"></style>
